function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7411",
  transform: "translate(8947.809 3895.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2801",
  className: "cls-2",
  d: "M-182.551 17.355a7.066 7.066 0 0 1-1.146-4.019l.043-.914a1.023 1.023 0 0 0-1.113-1.062h-.026a1.012 1.012 0 0 0-.927.895 9.479 9.479 0 0 0-.063 1.08 9.658 9.658 0 0 0 1.425 5.059 1.036 1.036 0 0 0 1.688.138l.014-.017a1 1 0 0 0 .105-1.16z",
  transform: "translate(-8760.549 -3897.462)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4403",
  transform: "translate(-8946.266 -3894.022)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2802",
  className: "cls-2",
  d: "M-182.35 10.5a3.374 3.374 0 0 1-3.366-3.218 3.375 3.375 0 0 1 3.216-3.516 3.379 3.379 0 0 1 3.518 3.214 3.374 3.374 0 0 1-3.218 3.52h-.15zm0-4.654h-.058a1.287 1.287 0 0 0-1.226 1.342 1.286 1.286 0 0 0 1.342 1.225 1.286 1.286 0 0 0 1.225-1.342 1.286 1.286 0 0 0-1.281-1.223z",
  transform: "translate(185.719 -3.763)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4404",
  transform: "translate(-8942.408 -3878.818)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2803",
  className: "cls-2",
  d: "M-178.645 25.085a3.372 3.372 0 0 1-2.845-1.554 3.375 3.375 0 0 1 1.025-4.655 3.363 3.363 0 0 1 2.539-.451 3.34 3.34 0 0 1 2.115 1.477 3.342 3.342 0 0 1 .451 2.538 3.345 3.345 0 0 1-1.476 2.117 3.347 3.347 0 0 1-1.809.528zm-.008-4.653a1.271 1.271 0 0 0-.689.2 1.286 1.286 0 0 0-.39 1.775 1.288 1.288 0 0 0 1.774.39 1.279 1.279 0 0 0 .563-.806 1.274 1.274 0 0 0-.172-.968 1.273 1.273 0 0 0-.807-.563 1.264 1.264 0 0 0-.279-.029z",
  transform: "translate(182.02 -18.346)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4405",
  transform: "translate(-8931.17 -3889.76)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2804",
  className: "cls-2",
  d: "M-167.878 14.591a3.35 3.35 0 0 1-1.545-.377 3.375 3.375 0 0 1-1.44-4.543 3.372 3.372 0 0 1 4.543-1.441 3.374 3.374 0 0 1 1.441 4.543 3.374 3.374 0 0 1-2.999 1.818zm.009-4.653a1.288 1.288 0 0 0-1.144.693 1.287 1.287 0 0 0 .551 1.732 1.284 1.284 0 0 0 1.731-.551 1.285 1.285 0 0 0-.548-1.731 1.273 1.273 0 0 0-.589-.144z",
  transform: "translate(171.24 -7.851)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_2805",
  className: "cls-2",
  d: "M-176.888 6.013a7.071 7.071 0 0 1 4.1.8l.794.454a1.023 1.023 0 0 0 1.451-.509l.01-.024a1.013 1.013 0 0 0-.376-1.232 9.456 9.456 0 0 0-.933-.546 9.67 9.67 0 0 0-5.155-1.027 1.035 1.035 0 0 0-.888 1.442l.008.02a1 1 0 0 0 .989.622z",
  transform: "translate(-8760.216 -3897.779)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2806",
  className: "cls-2",
  d: "M-169.6 16.451a7.078 7.078 0 0 1-2.857 3.051l-.806.434a1.021 1.021 0 0 0-.34 1.5l.016.022a1.012 1.012 0 0 0 1.244.335 9.452 9.452 0 0 0 .959-.5 9.661 9.661 0 0 0 3.6-3.825 1.036 1.036 0 0 0-.751-1.518h-.021a1 1 0 0 0-1.044.501z",
  transform: "translate(-8760.037 -3897.266)"
}));

function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.0c9eb1db.svg";
export { ForwardRef as ReactComponent };